import React from "react";
import { Icon } from "@iconify/react";

const GameboardIcon = () => (
  <Icon icon="lucide:gamepad-2" width={18} height={18} />
);

export default GameboardIcon;
